import type { JSX } from 'react';

import { useTestingCenterContext } from './TestingCenterLayout';
import ScenariosSection from './scenarios/ScenariosSection';

const TestingCenterScenariosPage = (): JSX.Element => {
  const { masterProject, subProjects } = useTestingCenterContext();

  return <ScenariosSection key={masterProject.id} masterProject={masterProject} subProjects={subProjects} />;
};

export default TestingCenterScenariosPage;
